import React, { useContext, useEffect, useState } from 'react';

import DesignPattern from './components/Tabs/DesignPattern';
import DesignCollar from './components/Tabs/DesignCollar';
import DesignSurface from "./components/Tabs/DesignSurface";

import Content from './components/Content';
import BuilderContext from '../../builder/hooks/context';
import pickBy from "lodash/pickBy";
import Markup from "../../markup";
import DesignSize from "./components/Tabs/DesignSize";
import { trackStage, trackSubStage, trackTimeSpentOnStage } from '../../utils/Analytics';


function Design() {
  const { builder } = useContext(BuilderContext);
  const [stageStartTime, setStageStartTime] = useState<number>(Date.now());

  const Components = {
    pattern: DesignPattern,
    collar: DesignCollar,
    surface: DesignSurface,
    size: DesignSize,
  };

  const filteredComponents = pickBy(Components, (value, key) => {
    switch(key){
      case "collar":return builder?.modelData?.collarList?.length;
      case "surface":return builder.modelData?.surffaceList?.length;
      case "size":return builder.modelData?.surffaceList?.length;
      default:return true;
    }
  })


  useEffect(() => {
    setStageStartTime(Date.now());

    return () => {
      trackTimeSpentOnStage('Design', stageStartTime);
    };
  }, []);


  useEffect(() => {
    trackStage('Design');
    trackSubStage('Design', 'Pattern');
  }, []);
  
  useEffect(() => {
    if(!builder?.animationState){
      builder?.setAnimationState(true);
      builder?.setCamera('front');
    }
  }, []);

  // Tell the interaction layer we're on the Design tab (no image/text interaction)
  useEffect(() => {
    builder?.setUiContext({ tab: 'Design' });
  }, []);

  return (
    <>
      <Markup.Screen.Logos.NoticeMessageTabs themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
        Unable to make changes to this item because it has already been added to cart
      </Markup.Screen.Logos.NoticeMessageTabs>
      <Markup.Screen.Name.DisableOverlayOther themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
      </Markup.Screen.Name.DisableOverlayOther>
      <Content Components={filteredComponents} page="design" />
    </>
  );
}

export default React.memo(Design);

